import ContentUpdateService from "JS/Services/ContentUpdate";

export const useContentUpdate = () => {
    const fetch = (contentType: string, cacheTime: number) => {
        const service = new ContentUpdateService();
        return new Promise<boolean>((res) =>
            service
                .getContentUpdate(contentType, cacheTime)
                .then((r) => res(r.data))
                .catch(() => res(false)),
        );
    };

    return { fetch };
};
